/**
 * Agente de Cafeteros Chile — widget del sitio.
 *
 *   <script async src="{{ 'chatbot.js' | asset_url }}"
 *           data-api="https://bot.cafeteroschile.cl"
 *           data-whatsapp="56982583899"
 *           data-abajo="92"></script>
 *
 * data-abajo (opcional): pixeles desde el borde inferior. Sirve cuando otra app
 * (Dondy WhatsApp, Loox...) ya ocupa la esquina inferior derecha: con 92 la
 * burbuja queda justo encima de un boton de 60px.
 *
 * Lo que hace que no se sienta un bot:
 *
 *  - RITMO. Los mensajes llegan de a uno, con "escribiendo..." entremedio y una
 *    pausa proporcional al largo del texto. Nadie escribe cuatro frases en cero
 *    segundos. Esto solo ya cambia por completo la sensacion.
 *  - MEMORIA. La conversacion sobrevive a la navegacion y a cerrar la pestana.
 *    Si vuelve al otro dia, retoma donde quedaron en vez de saludar de nuevo.
 *  - INICIATIVA. Si le recomendo algo y el cliente se quedo callado, vuelve a
 *    hablar. Si volvio al sitio, lo saluda por lo que quedo pendiente. Esos
 *    empujones no pasan por el modelo: son instantaneos y no cuestan.
 *  - CONTEXTO. Sabe en que ficha esta parado y que tiene en el carrito.
 *
 * UN SOLO BOTON. En horario de oficina el agente se apaga y la burbuja se
 * convierte en el boton verde de WhatsApp, que abre WhatsApp directo: ahi esta el
 * equipo de verdad. Fuera de horario la burbuja es Javi. El cliente nunca tiene
 * que elegir entre dos botones. (Por eso la app Dondy WhatsApp Chat sobra.)
 */
(function () {
  'use strict'

  if (window.__cafeterosAgente) return
  window.__cafeterosAgente = true

  var script = document.currentScript
  var BASE = ((script && script.getAttribute('data-api')) || '').replace(/\/+$/, '')
  var WSP = (script && script.getAttribute('data-whatsapp')) || '56982583899'
  var COLOR = (script && script.getAttribute('data-color')) || '#101B33'
  var ABAJO = parseInt(script && script.getAttribute('data-abajo'), 10) || 20
  if (!BASE) return console.warn('[agente] falta data-api')

  var ESPERA_EMPUJON = 75000     // silencio tras una recomendacion
  var ESPERA_TEASER = 45000      // cuanto esperar antes de asomarse solo
  var VUELTA_MINIMA = 30 * 60e3  // desde cuando se considera "volvio"

  // -- memoria del cliente ------------------------------------------------

  function leer(clave, porDefecto) {
    try { return JSON.parse(localStorage.getItem(clave)) || porDefecto } catch (e) { return porDefecto }
  }
  function escribir(clave, valor) {
    try { localStorage.setItem(clave, JSON.stringify(valor)) } catch (e) {}
  }

  var memoria = leer('cafeteros_agente', { sesion: null, visitas: 0, ultima: 0, producto: null })
  if (!memoria.sesion) memoria.sesion = 's_' + Math.random().toString(36).slice(2) + Date.now().toString(36)
  var volvio = memoria.ultima && (Date.now() - memoria.ultima > VUELTA_MINIMA)
  memoria.visitas = (memoria.visitas || 0) + 1
  memoria.ultima = Date.now()
  escribir('cafeteros_agente', memoria)

  function historial(nuevo) {
    if (nuevo) return escribir('cafeteros_agente_hist', nuevo.slice(-40))
    return leer('cafeteros_agente_hist', [])
  }

  // -- contexto de la pagina ---------------------------------------------

  var carrito = null
  function leerCarrito() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null })
      .then(function (c) {
        carrito = (c && c.items && c.items.length)
          ? c.items.map(function (i) { return i.quantity + 'x ' + i.product_title }).join(', ')
          : null
      })
      .catch(function () {})
  }

  function contexto() {
    var ctx = { visitas: memoria.visitas }
    var m = location.pathname.match(/\/products\/([^/?#]+)/)
    if (m) ctx.producto = decodeURIComponent(m[1])
    var c = location.pathname.match(/\/collections\/([^/?#]+)/)
    if (c && !m) ctx.coleccion = decodeURIComponent(c[1])
    if (carrito) ctx.carrito = carrito
    return ctx
  }

  // -- interfaz -----------------------------------------------------------

  var host = document.createElement('div')
  host.style.cssText = 'position:fixed;bottom:0;right:0;z-index:2147483647'
  document.body.appendChild(host)
  var raiz = host.attachShadow({ mode: 'open' })

  raiz.innerHTML = [
    '<style>',
    ':host,*{box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif}',
    '.burbuja{position:fixed;bottom:' + ABAJO + 'px;right:20px;width:58px;height:58px;border-radius:50%;border:0;',
    'cursor:pointer;background:' + COLOR + ';color:#fff;font-size:26px;line-height:1;box-shadow:0 6px 24px rgba(0,0,0,.28);transition:transform .15s}',
    '.burbuja:hover{transform:scale(1.06)}',
    '.burbuja.wsp{background:#25D366}',
    '.burbuja svg{width:32px;height:32px;fill:#fff;display:block;margin:auto}',
    '.punto{position:absolute;top:-2px;right:-2px;width:14px;height:14px;border-radius:50%;background:#E5484D;border:2px solid #fff;display:none}',
    '.burbuja.avisa .punto{display:block}',
    '.teaser{position:fixed;bottom:' + (ABAJO + 68) + 'px;right:20px;max-width:250px;background:#fff;border-radius:14px;',
    'padding:12px 14px;font-size:13.5px;line-height:1.45;color:#111;box-shadow:0 8px 30px rgba(0,0,0,.2);',
    'cursor:pointer;display:none;border-bottom-right-radius:4px}',
    '.teaser.visible{display:block;animation:entra .3s ease-out}',
    '.teaser .x{position:absolute;top:4px;right:8px;color:#9A9AA2;font-size:16px;line-height:1}',
    '@keyframes entra{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
    '.panel{position:fixed;bottom:' + ABAJO + 'px;right:20px;width:390px;max-width:calc(100vw - 32px);height:600px;',
    'max-height:calc(100vh - ' + (ABAJO + 20) + 'px);background:#fff;border-radius:16px;display:none;flex-direction:column;',
    'overflow:hidden;box-shadow:0 12px 48px rgba(0,0,0,.24)}',
    '.panel.abierto{display:flex}',
    '@media(max-width:640px){.panel{inset:0;width:100%;height:100%;max-width:100%;max-height:100%;border-radius:0}}',
    '.cabecera{background:' + COLOR + ';color:#fff;padding:13px 16px;display:flex;align-items:center;gap:10px;flex:0 0 auto}',
    '.avatar{width:34px;height:34px;border-radius:50%;background:rgba(255,255,255,.18);display:flex;',
    'align-items:center;justify-content:center;font-size:17px;flex:0 0 auto}',
    '.cabecera b{font-size:14.5px;display:block}',
    '.cabecera small{opacity:.8;font-size:11.5px;display:flex;align-items:center;gap:5px}',
    '.led{width:7px;height:7px;border-radius:50%;background:#3FCF6A;display:inline-block}',
    '.cerrar{margin-left:auto;background:none;border:0;color:#fff;font-size:24px;cursor:pointer;opacity:.8;line-height:1}',
    '.hilo{flex:1 1 auto;overflow-y:auto;padding:16px;background:#F7F7F8;display:flex;flex-direction:column;gap:9px}',
    '.msg{max-width:85%;padding:10px 13px;border-radius:15px;font-size:14px;line-height:1.5;',
    'white-space:pre-wrap;word-wrap:break-word;animation:entra .25s ease-out}',
    '.bot{background:#fff;align-self:flex-start;border-bottom-left-radius:5px;box-shadow:0 1px 2px rgba(0,0,0,.08)}',
    '.yo{background:' + COLOR + ';color:#fff;align-self:flex-end;border-bottom-right-radius:5px}',
    '.tarjeta{background:#fff;border:1px solid #E6E6E9;border-radius:12px;padding:10px;display:flex;gap:10px;align-self:stretch;animation:entra .25s}',
    '.tarjeta img{width:56px;height:56px;object-fit:cover;border-radius:8px;flex:0 0 auto;background:#F0F0F2}',
    '.tarjeta .info{flex:1 1 auto;min-width:0}',
    '.tarjeta .tit{font-size:13px;font-weight:600;line-height:1.3;color:#111;text-decoration:none;display:block}',
    '.tarjeta .precio{font-size:14px;font-weight:700;color:' + COLOR + ';margin-top:2px;display:block}',
    '.tarjeta button{margin-top:7px;background:' + COLOR + ';color:#fff;border:0;border-radius:8px;',
    'padding:7px 12px;font-size:12px;font-weight:600;cursor:pointer;width:100%}',
    '.tarjeta button[disabled]{opacity:.55;cursor:default}',
    '.chips{display:flex;flex-wrap:wrap;gap:6px}',
    '.chips button{background:#fff;border:1px solid #D9D9DE;border-radius:999px;padding:7px 12px;font-size:12.5px;cursor:pointer;color:#333}',
    '.cta{display:block;background:#25D366;color:#fff;text-align:center;padding:11px;border-radius:10px;',
    'font-size:13.5px;font-weight:600;text-decoration:none;align-self:stretch}',
    '.cta.oscuro{background:' + COLOR + '}',
    '.aviso{font-size:12.5px;color:#77777F;text-align:center;padding:4px 10px;line-height:1.45}',
    '.pie{flex:0 0 auto;display:flex;gap:8px;padding:12px;border-top:1px solid #EAEAEE;background:#fff}',
    '.pie input{flex:1;border:1px solid #D9D9DE;border-radius:10px;padding:11px 13px;font-size:14px;outline:none}',
    '.pie input:focus{border-color:' + COLOR + '}',
    '.pie button{background:' + COLOR + ';color:#fff;border:0;border-radius:10px;padding:0 16px;font-size:16px;cursor:pointer}',
    '.pie.oculto{display:none}',
    '.puntos span{display:inline-block;width:6px;height:6px;margin-right:3px;border-radius:50%;background:#B5B5BC;animation:s 1.2s infinite}',
    '.puntos span:nth-child(2){animation-delay:.2s}.puntos span:nth-child(3){animation-delay:.4s}',
    '@keyframes s{0%,60%,100%{opacity:.3}30%{opacity:1}}',
    '</style>',
    '<button class="burbuja" aria-label="Abrir chat">☕<span class="punto"></span></button>',
    '<div class="teaser"><span class="x">×</span><span class="texto"></span></div>',
    '<div class="panel" role="dialog" aria-label="Chat de Cafeteros Chile">',
    '  <div class="cabecera"><div class="avatar">☕</div><div><b class="nombre">Javi</b>',
    '  <small><span class="led"></span><span class="sub">Cafeteros Chile</span></small></div>',
    '  <button class="cerrar" aria-label="Cerrar">×</button></div>',
    '  <div class="hilo"></div>',
    '  <form class="pie"><input type="text" placeholder="Escribe aca..." autocomplete="off">',
    '  <button type="submit" aria-label="Enviar">➤</button></form>',
    '</div>',
  ].join('')

  var burbuja = raiz.querySelector('.burbuja')
  var teaser = raiz.querySelector('.teaser')
  var panel = raiz.querySelector('.panel')
  var hilo = raiz.querySelector('.hilo')
  var form = raiz.querySelector('.pie')
  var input = raiz.querySelector('.pie input')

  function abajo() { hilo.scrollTop = hilo.scrollHeight }
  function esperar(ms) { return new Promise(function (r) { setTimeout(r, ms) }) }

  function globo(texto, quien) {
    var d = document.createElement('div')
    d.className = 'msg ' + quien
    d.textContent = texto
    hilo.appendChild(d)
    abajo()
    return d
  }

  function escribiendo() {
    var d = document.createElement('div')
    d.className = 'msg bot puntos'
    d.innerHTML = '<span></span><span></span><span></span>'
    hilo.appendChild(d)
    abajo()
    return d
  }

  // El corazon de que se sienta humano: uno a la vez, con pausa segun el largo.
  function decir(mensajes, guardar) {
    return mensajes.reduce(function (cadena, texto) {
      return cadena.then(function () {
        var puntos = escribiendo()
        return esperar(Math.min(2400, 500 + texto.length * 24)).then(function () {
          puntos.remove()
          globo(texto, 'bot')
          if (guardar !== false) {
            var h = historial()
            h.push({ q: 'bot', t: texto })
            historial(h)
          }
          return esperar(220)
        })
      })
    }, Promise.resolve())
  }

  function tarjeta(p, guardar) {
    var d = document.createElement('div')
    d.className = 'tarjeta'
    var img = document.createElement('img')
    img.src = p.imagen || ''
    img.alt = ''
    img.loading = 'lazy'
    var info = document.createElement('div')
    info.className = 'info'
    var a = document.createElement('a')
    a.className = 'tit'
    a.href = p.url
    a.textContent = p.titulo
    var precio = document.createElement('span')
    precio.className = 'precio'
    precio.textContent = p.precio_texto || p.precio
    info.appendChild(a)
    info.appendChild(precio)
    if (p.al_carrito) {
      var b = document.createElement('button')
      b.textContent = 'Agregar al carrito'
      b.onclick = function () { agregar(p, b) }
      info.appendChild(b)
    }
    d.appendChild(img)
    d.appendChild(info)
    hilo.appendChild(d)
    abajo()

    memoria.producto = p.titulo
    escribir('cafeteros_agente', memoria)
    if (guardar !== false) {
      var h = historial()
      if (h.length) { h[h.length - 1].p = (h[h.length - 1].p || []).concat([p]); historial(h) }
    }
  }

  // El id de variante viene dentro del link /cart/<id>:1 que arma el servidor.
  function agregar(p, boton) {
    var id = (p.al_carrito.match(/\/cart\/(\d+):/) || [])[1]
    if (!id) return (location.href = p.al_carrito)
    boton.disabled = true
    boton.textContent = 'Agregando...'
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then(function (r) { if (!r.ok) throw new Error('no'); return r.json() })
      .then(function () {
        boton.textContent = '✓ Agregado'
        cancelarEmpujon()
        leerCarrito()
        var ir = document.createElement('a')
        ir.className = 'cta oscuro'
        ir.href = '/cart'
        ir.textContent = 'Ir a pagar'
        hilo.appendChild(ir)
        abajo()
      })
      .catch(function () {
        boton.disabled = false
        boton.textContent = 'Agregar al carrito'
        location.href = p.al_carrito
      })
  }

  function whatsapp(texto) {
    var a = document.createElement('a')
    a.className = 'cta'
    a.target = '_blank'
    a.rel = 'noopener'
    a.href = 'https://wa.me/' + WSP + '?text=' + encodeURIComponent(texto || 'Hola, vengo del chat de la web.')
    a.textContent = 'Seguir por WhatsApp'
    hilo.appendChild(a)
    abajo()
  }

  function chips(opciones) {
    var cont = document.createElement('div')
    cont.className = 'chips'
    opciones.forEach(function (s) {
      var b = document.createElement('button')
      b.textContent = s
      b.onclick = function () { cont.remove(); enviar(s) }
      cont.appendChild(b)
    })
    hilo.appendChild(cont)
    abajo()
  }

  // -- iniciativa: volver a hablar solo -----------------------------------

  var temporizador = null
  function cancelarEmpujon() { clearTimeout(temporizador); temporizador = null }

  function programarEmpujon(producto) {
    cancelarEmpujon()
    temporizador = setTimeout(function () {
      pedirEmpujon('nudge', producto)
    }, ESPERA_EMPUJON)
  }

  function pedirEmpujon(tipo, producto) {
    fetch(BASE + '/empujon', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tipo: tipo, producto: producto || null, semilla: memoria.visitas }),
    })
      .then(function (r) { return r.json() })
      .then(function (d) {
        if (!d.mensajes || !d.mensajes.length) return
        if (panel.classList.contains('abierto')) decir(d.mensajes)
        else mostrarTeaser(d.mensajes[0])
      })
      .catch(function () {})
  }

  function mostrarTeaser(texto) {
    if (sessionStorage.getItem('cafeteros_teaser')) return
    sessionStorage.setItem('cafeteros_teaser', '1')
    raiz.querySelector('.teaser .texto').textContent = texto
    teaser.classList.add('visible')
    burbuja.classList.add('avisa')
  }

  teaser.onclick = function (e) {
    if (e.target.className === 'x') { teaser.classList.remove('visible'); return }
    teaser.classList.remove('visible')
    abrir()
  }

  // -- conversacion -------------------------------------------------------

  var activo = true

  function enviar(texto) {
    texto = (texto || input.value).trim()
    if (!texto) return
    input.value = ''
    cancelarEmpujon()
    globo(texto, 'yo')
    var h = historial()
    h.push({ q: 'yo', t: texto })
    historial(h)

    var puntos = escribiendo()
    fetch(BASE + '/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sesion: memoria.sesion, mensaje: texto, contexto: contexto() }),
    })
      .then(function (r) { return r.json() })
      .then(function (d) {
        puntos.remove()
        return decir(d.mensajes || []).then(function () {
          ;(d.productos || []).forEach(function (p) { tarjeta(p) })
          if (d.derivar) whatsapp('Hola, vengo del chat de la web. ' + texto)
          if (d.bot_activo === false) apagarEntrada(d)
          if ((d.productos || []).length) programarEmpujon(d.productos[0].titulo)
        })
      })
      .catch(function () {
        puntos.remove()
        globo('Se me cayo la conexion. Escribeme por WhatsApp y te respondo al tiro.', 'bot')
        whatsapp('Hola, el chat de la web fallo. Mi consulta: ' + texto)
      })
  }

  function apagarEntrada(estado) {
    activo = false
    form.classList.add('oculto')
    var a = document.createElement('a')
    a.className = 'cta'
    a.target = '_blank'
    a.rel = 'noopener'
    a.href = (estado && estado.whatsapp) || 'https://wa.me/' + WSP
    a.textContent = 'Escribir por WhatsApp'
    hilo.appendChild(a)
    abajo()
  }

  // -- estado del agente: una sola consulta, compartida ----------------------

  var _estado = null
  function pedirEstado() {
    if (!_estado) {
      _estado = fetch(BASE + '/estado').then(function (r) { return r.json() })
      _estado.catch(function () { _estado = null })
    }
    return _estado
  }

  // Un solo boton: en horario de oficina la burbuja ES el boton de WhatsApp.
  var WSP_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2m0 1.67c4.54 0 8.24 3.7 8.24 8.24s-3.7 8.24-8.24 8.24c-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24m-3.5 4.1c-.16 0-.43.06-.65.3-.23.24-.87.85-.87 2.07s.89 2.4 1.01 2.57c.13.17 1.75 2.67 4.23 3.74 2.06.81 2.48.65 2.93.61.45-.04 1.45-.59 1.65-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.16-.47-.28-.24-.12-1.45-.72-1.68-.8-.22-.08-.39-.12-.55.12-.16.24-.63.8-.77.96-.14.16-.28.18-.53.06-.24-.12-1.03-.38-1.96-1.21-.72-.65-1.21-1.45-1.36-1.69-.14-.24-.01-.37.11-.5.11-.11.24-.28.37-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.41-.55-.42h-.47"/></svg>'

  function modoWhatsapp(e) {
    burbuja.classList.add('wsp')
    burbuja.innerHTML = WSP_SVG + '<span class="punto"></span>'
    burbuja.setAttribute('aria-label', 'Escribir por WhatsApp')
    // Un <a> de verdad, no window.open: Chrome bloquea api.whatsapp.com con
    // ERR_BLOCKED_BY_RESPONSE cuando se abre por script con noopener.
    burbuja.onclick = function () {
      var a = document.createElement('a')
      a.href = (e && e.whatsapp) || 'https://wa.me/' + WSP
      a.target = '_blank'
      a.rel = 'noopener'
      raiz.appendChild(a)
      a.click()
      a.remove()
    }
  }

  pedirEstado().then(function (e) { if (!e.bot_activo) modoWhatsapp(e) }).catch(function () {})

  // -- apertura -----------------------------------------------------------

  var pintado = false
  function pintarHistorial() {
    var h = historial()
    h.forEach(function (m) {
      globo(m.t, m.q)
      ;(m.p || []).forEach(function (p) { tarjeta(p, false) })
    })
    return h.length > 0
  }

  function abrir() {
    panel.classList.add('abierto')
    burbuja.style.display = 'none'
    burbuja.classList.remove('avisa')
    teaser.classList.remove('visible')
    if (window.innerWidth > 640 && activo) input.focus()
    if (pintado) return
    pintado = true

    var habia = pintarHistorial()

    pedirEstado()
      .then(function (e) {
        raiz.querySelector('.nombre').textContent = e.agente || 'Cafetero'
        if (!e.bot_activo) {
          raiz.querySelector('.sub').textContent = 'El equipo esta en linea'
          decir(['Hola. A esta hora esta el equipo atendiendo, asi que te dejo con ellos.',
                 'Escribenos por WhatsApp y te responden al tiro.'], false)
            .then(function () { apagarEntrada(e) })
          return
        }
        raiz.querySelector('.sub').textContent = e.mensaje || 'Cafeteros Chile'
        if (habia && volvio && memoria.producto) {
          pedirEmpujon('vuelta', memoria.producto)
        } else if (!habia) {
          decir(['Hola! ¿Qué tal?',
                 'Voy a dar mi 100% para resolver tus dudas, cuéntame cómo te puedo ayudar...'])
            .then(function () {
              chips(['Cafe para cafetera italiana', 'Algo suave, poco amargo', 'Compro para mi negocio'])
            })
        }
      })
      .catch(function () {
        if (!habia) decir(['Hola! ¿Qué tal?',
                           'Voy a dar mi 100% para resolver tus dudas, cuéntame cómo te puedo ayudar...'])
      })
  }

  burbuja.onclick = abrir
  raiz.querySelector('.cerrar').onclick = function () {
    panel.classList.remove('abierto')
    burbuja.style.display = ''
  }
  form.onsubmit = function (e) { e.preventDefault(); enviar() }

  // Si volvio al sitio y habia quedado algo pendiente, se asoma solo.
  if (volvio && memoria.producto) {
    setTimeout(function () {
      if (!panel.classList.contains('abierto')) pedirEmpujon('vuelta', memoria.producto)
    }, ESPERA_TEASER)
  }

  leerCarrito()
})()
